'use client'

import { useTranslations } from 'next-intl'
import { ReactNode } from 'react'

import { TPaymentMethod } from '@/entities/contract'
import { passPropsToChildren } from '@/shared/lib'
import { AlertDialog, Button, Icon } from '@/shared/ui'

import { PaymentDialog } from './dialog'
import { DIALOG, usePayment } from '../lib/payment'

export type PaymentValues = {
  roomName: string
  startDate: string
  endDate: string
  finalPayFee: number
}

type Props = PaymentValues & {
  paymentMethod: TPaymentMethod
  asChild?: boolean
  children?: ReactNode
}

export const PaymentButton = ({
  paymentMethod,
  roomName,
  startDate,
  endDate,
  finalPayFee,
  asChild,
  children,
}: Props) => {
  const t = useTranslations()

  const { requestPayment, isDialogOpen, closeDialog } = usePayment()

  const handleClick = async () => {
    await requestPayment({
      method: paymentMethod,
    })
  }

  return (
    <>
      {(() => {
        if (asChild) {
          return passPropsToChildren(children, { onClick: handleClick })
        }

        return (
          <Button size="medium" shape="pill" fullWidth onClick={handleClick}>
            {t('lease_detail.make_payment.card.button.go_to_pay')}
            <Icon name="arrow-right" size={16} />
          </Button>
        )
      })()}

      <AlertDialog
        isOpen={isDialogOpen(DIALOG.ACCOUNT_NOTICE)}
        onOpenChange={closeDialog(DIALOG.ACCOUNT_NOTICE)}
        title={t('lease_detail.dialog.bank_transfer_required.title')}
        content={t('lease_detail.dialog.bank_transfer_required.description')}
      />

      <PaymentDialog
        isOpen={isDialogOpen(DIALOG.CARD_PAYMENT)}
        onOpenChange={closeDialog(DIALOG.CARD_PAYMENT)}
        roomName={roomName}
        startDate={startDate}
        endDate={endDate}
        finalPayFee={finalPayFee}
      />
    </>
  )
}
